import React from 'react';
import { ShieldCheck, Lock } from 'lucide-react';
export function PricingSection() {
  const handleCheckout = () => {
    window.location.href = 'https://productosdigitalesnuevos.myshopify.com/checkouts/cn/hWN9n9b8dLQ0zWcM4lh6BQg6/es-ar?_r=AQAB3sxDrVfYMB8G5oC3KtOEXxVl3WNVcpKRPbVzMknQ1i0&cart_link_id=QdC5wTSR&preview_theme_id=146146721979';
  };
  return <section className="py-20 bg-[#0d0906] relative overflow-hidden" data-id="element-79">
      {/* Decorative background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#d4a843]/10 rounded-full blur-[120px] pointer-events-none" data-id="element-80"></div>

      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-81">
        <div className="text-center mb-12" data-id="element-82">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-83">
            Invertí en tu <span className="gold-gradient-text" data-id="element-84">futuro hoy</span>
          </h2>
          <p className="text-lg text-[#c9b99a]" data-id="element-85">
            Un emprendimiento simple, delicioso y con baja inversión.
          </p>
        </div>

        <div className="glass-card border-[#d4a843]/30 p-8 md:p-12 text-center relative overflow-hidden" data-id="element-86">
          {/* Badge */}
          <div className="absolute top-6 right-0 bg-gradient-to-r from-[#d4a843] to-[#f0c14b] text-[#1a1008] font-bold py-1 px-10 shadow-lg transform translate-x-8 rotate-45" data-id="element-87">
            OFERTA
          </div>

          <h3 className="text-2xl font-bold text-white mb-2" data-id="element-88">
            ACCESO COMPLETO AL CURSO
          </h3>
          <p className="text-[#c9b99a] mb-8" data-id="element-89">
            Abono único, acceso de por vida.
          </p>

          <div className="flex flex-col items-center justify-center mb-8" data-id="element-90">
            <span className="text-2xl text-white/50 line-through decoration-red-500/50 mb-2" data-id="element-91">
              $49.990
            </span>
            <div className="text-6xl md:text-7xl font-extrabold gold-gradient-text drop-shadow-[0_0_15px_rgba(212,168,67,0.3)]" data-id="element-92">
              $29.990
            </div>
            <span className="text-[#c9b99a] mt-2 text-sm" data-id="element-93">
              Pesos Argentinos
            </span>
          </div>

          <div className="inline-block bg-[#d4a843]/10 border border-[#d4a843]/30 text-[#f0c14b] px-6 py-2 rounded-full font-semibold mb-10" data-id="element-94">
            Oferta especial por tiempo limitado
          </div>

          <button onClick={handleCheckout} className="btn-gold animate-shimmer-btn w-full max-w-md mx-auto flex items-center justify-center gap-2 text-xl py-5 mb-6" data-id="element-95">
            <Lock className="w-6 h-6" data-id="element-96" />
            Comprar Ahora - Pago Seguro
          </button>

          <div className="flex items-center justify-center gap-2 text-[#c9b99a] mb-8 bg-white/5 py-3 px-4 rounded-lg inline-flex mx-auto" data-id="element-97">
            <ShieldCheck className="w-6 h-6 text-green-400" data-id="element-98" />
            <span className="text-sm md:text-base" data-id="element-99">
              30 días de garantía - Si no te gusta, te devolvemos tu dinero
            </span>
          </div>

          <div className="pt-8 border-t border-white/10" data-id="element-100">
            <p className="text-sm text-[#c9b99a]/70 mb-4" data-id="element-101">
              Pagos 100% seguros procesados por Mercado Pago
            </p>
            <div className="flex justify-center gap-4 opacity-70 grayscale hover:grayscale-0 transition-all" data-id="element-102">
              {/* Placeholder for payment icons, using text/simple shapes since we don't have image assets for them */}
              <div className="px-3 py-1 bg-white rounded text-[#0d0906] font-bold text-xs flex items-center" data-id="element-103">
                VISA
              </div>
              <div className="px-3 py-1 bg-white rounded text-[#0d0906] font-bold text-xs flex items-center" data-id="element-104">
                MASTERCARD
              </div>
              <div className="px-3 py-1 bg-[#009EE3] rounded text-white font-bold text-xs flex items-center" data-id="element-105">
                mercado pago
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}